import Vue from 'vue';
import Vuex from "vuex";

Vue.use(Vuex);

import state from './state';
import mutations from './mutations';
import actions from './actions';
import {CognitoUser} from 'amazon-cognito-identity-js';
import {CognitoIdentityCredentials} from 'aws-sdk/global';

import {BucketDir, BucketFile} from "@/store/types";

export interface RootState {
    loginUrl: string;
    logged: boolean;
    user: CognitoUser | null;
    credentials: CognitoIdentityCredentials | null;
    files: BucketFile[];
    nodesStack: BucketDir[];
}

export default new Vuex.Store<RootState>({
    state,
    mutations,
    actions
})
